import React from 'react';
import {View} from 'react-native';
import {styles} from './styles';

export const NullControl = () => {
  return <View style={[styles.control]} />;
};
